/** @format */
import { safeCurrentLanguage } from '@services/drupal-services';

/**
 * Homepage Services.
 */
export const homePageServices = (): void => {
  /**
   * Localize news link.
   *
   * Reset news link for latin america spanish.
   */
  const localizeNewsLink = (): void => {
    const newsLink: HTMLAnchorElement | null = document.querySelector(
      '.home-page-news .btn-primary'
    );
    if (newsLink) {
      if (safeCurrentLanguage() === 'es-419') {
        const newsUrl = newsLink.href.replace('es-419', 'es-xl');
        newsLink.href = newsUrl;
      }
    }
  };
  localizeNewsLink();

  /**
   * Get local blog url.
   */
  const getLocalBlogUrl = (url: string): string => {
    let localeBlog = url;
    switch (safeCurrentLanguage()) {
      case 'fi':
        localeBlog = '/fi/resources-support/blogs/finland';
        break;
      case 'zh-hans':
        localeBlog = '/zh-hans/about-varian/varian-china/blog';
        break;
      case 'es-419':
        localeBlog = '/es-xl/resources-support/blogs';
        break;
    }
    return localeBlog;
  };

  /**
   * Localize blog Link.
   */
  const localizeBlogLink = (): void => {
    const blogsLink: HTMLAnchorElement | null = document.querySelector(
      '.home-page-blogs .btn-primary'
    );
    if (blogsLink) {
      const url = getLocalBlogUrl(blogsLink.href);
      blogsLink.href = url;
    }
  };
  localizeBlogLink();
};
